<template>
  <section
    class="section-home-blog tw-pt-16 md:tw-pt-0"
    :style="`background-color: var(--${backgroundColor}) !important`"
  >
    <div class="page-padding">
      <div class="container-large">
        <div class="padding-vertical padding-xhuge" style="padding-bottom: 0">
          <div class="top-blog-content tw-flex tw-flex-col tw-items-center md:tw-flex-row">
            <div class="max-width-large tw-mr-3">
              <h2
                :class="title.type === 'keyword' ? 'heading-small' : 'heading-medium'"
                style="transition: all 1s; text-transform: capitalize"
              >
                {{ title.text }}
              </h2>
            </div>
            <div class="w-100">
              <search-box
                v-model="keyword"
                :search-result-list="[]"
                :placeholder="searchBoxPlaceholder"
                :search-method="onSearched"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { Component } from '~/types';
import IndexGlobal from '~/mixins/index.global';
import SearchBox from '~/components/common/SearchBox.vue';
import { ComponentMixin } from '~/mixins/component.mixin';
import { BlogsMetaMixins } from '~/mixins/blogsMeta.mixins';

export default defineNuxtComponent({
  name: 'BlogsTopBar',
  components: { SearchBox },

  mixins: [IndexGlobal, ComponentMixin, BlogsMetaMixins],

  props: {
    component: {
      required: true,
      type: Object as PropType<Component>,
    },
  },

  computed: {
    searchBoxPlaceholder(): string {
      return getVariable(this.component, 'search_box_label-text') as string;
    },

    backgroundColor() {
      return getVariable(this.component, 'background-color');
    },
  },
});
</script>

<style scoped></style>
